var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.gruppi && _vm.gruppi.length > 0
        ? _c(
            "v-list",
            { attrs: { "two-line": "" } },
            [
              _vm._l(_vm.gruppi, function (gruppo, i) {
                return [
                  i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
                  _c("ItemListGruppoDistinteConsumi", {
                    key: gruppo.id,
                    attrs: { "data-test": "lista-gruppi", gruppo: gruppo },
                  }),
                ]
              }),
            ],
            2
          )
        : _c(
            "v-alert",
            {
              staticStyle: { margin: "0 24px" },
              attrs: { text: "", type: "info" },
            },
            [
              _vm._v(
                " Nessuna distinta trovata per i parametri specificati... "
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }